module.exports = __webpack_public_path__ + "img/58ne.7e14820c.svg";